import Image from 'next/image';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ImageStyle } from './WPImage.module.css';
import { useEffect, useState } from 'react';

const WPImage = ({
  sourceUrl,
  altText,
  className,
  height,
  width,
  mediaDetails,
  isHeroImage,
}) => {
  const [containerSize, setContainerSize] = useState({
    width: null,
    height: null,
  });
  const classes = classnames(ImageStyle, className);

  useEffect(() => {
    if (!isHeroImage) return;
    const handleResize = () => {
      const parent = document.getElementById('wp-image-container');
      if (parent) {
        const { width, height } = parent.getBoundingClientRect();
        setContainerSize({ width, height });
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isHeroImage]);

  const imageHeight = mediaDetails?.height || height || 50;
  const imageWidth = mediaDetails?.width || width || 50;
  const src = mediaDetails?.sizes?.medium?.sourceUrl || sourceUrl;

  const finalWidth =
    isHeroImage && containerSize.width
      ? Math.min(containerSize.width, imageWidth)
      : imageWidth;
  const finalHeight =
    isHeroImage && containerSize.height
      ? Math.min(containerSize.height, imageHeight)
      : imageHeight;

  const imageProps = {
    src: src || '/assets/images/1-grey-pixel.jpg',
    width: finalWidth,
    height: finalHeight,
    className: classes,
    quality: isHeroImage ? 65 : 50,
    loading: isHeroImage ? 'eager' : 'lazy',
    sizes: isHeroImage ? '100vw' : '(max-width: 768px) 50vw, 33vw',
    placeholder: 'empty',
  };

  return isHeroImage ? (
    <div id="wp-image-container">
      <Image alt={altText} {...imageProps} priority={isHeroImage} />
    </div>
  ) : (
    <Image alt={altText} {...imageProps} />
  );
};

WPImage.defaultProps = {
  altText: '',
};

WPImage.propTypes = {
  sourceUrl: PropTypes.string.isRequired,
  altText: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  mediaDetails: PropTypes.object,
  isHeroImage: PropTypes.bool,
};

export default WPImage;
